import React, { useEffect, useState } from "react";
import { X, Download } from "lucide-react";
import { useApp } from "@/context/AppContext";

const DISMISS_KEY = "pwa_prompt_dismissed_v1";

export default function InstallPrompt() {
  const { t } = useApp();
  const [deferred, setDeferred] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (localStorage.getItem(DISMISS_KEY)) return;
    // If already running standalone (installed) do nothing
    const standalone = window.matchMedia?.("(display-mode: standalone)")?.matches
                     || window.navigator.standalone === true;
    if (standalone) return;
    const onBeforeInstall = (e) => {
      e.preventDefault();
      setDeferred(e);
      setVisible(true);
    };
    window.addEventListener("beforeinstallprompt", onBeforeInstall);
    return () => window.removeEventListener("beforeinstallprompt", onBeforeInstall);
  }, []);

  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY, "1");
    setVisible(false);
  };
  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    try { await deferred.userChoice; } catch (e) {}
    localStorage.setItem(DISMISS_KEY, "1");
    setVisible(false);
    setDeferred(null);
  };

  if (!visible) return null;
  return (
    <div className="fixed left-2 right-2 bottom-20 md:left-auto md:right-6 md:bottom-6 md:w-96 z-50" data-testid="pwa-install-banner">
      <div className="rounded-2xl bg-[#B45309] text-white shadow-lg p-4 flex items-center gap-3">
        <Download className="w-5 h-5 shrink-0" />
        <div className="flex-1 min-w-0">
          <div className="font-semibold text-sm">{t("pwa_install_title")}</div>
          <div className="text-xs text-white/85 leading-snug mt-0.5">{t("pwa_install_help")}</div>
        </div>
        <button onClick={install} data-testid="pwa-install-btn" className="h-9 px-3 rounded-lg bg-white text-[#B45309] text-xs font-bold shrink-0">
          {t("install")}
        </button>
        <button onClick={dismiss} data-testid="pwa-install-dismiss" className="h-9 w-9 grid place-items-center rounded-lg bg-white/10 hover:bg-white/20 shrink-0">
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
